export const EXPERTISES_EN = [
    {
        slug: "diagnostic-strategie-export",
        num: "01",
        title: "Export diagnosis & strategy",
        tagline: "Assess, decide, plan.",
        image: "/assets/terrain-mission-bureau.jpg",
        imageAspect: "aspect-[3/4]",
        imageAlt: "WEYB mission — working session with a supported company",
        intro: "Before any international development, a company must know precisely where it starts from and where it can go. The export diagnosis measures your readiness; the strategy sets your course.",
        points: [
            { title: "Export diagnosis", desc: "Analysis of your offer, capabilities, resources and international experience." },
            { title: "International readiness", desc: "Assessment of your organisation, tools and teams against export requirements." },
            { title: "Export strategy", desc: "Defining objectives, positioning and ambitions by market." },
            { title: "Market prioritisation", desc: "Ranking the highest-potential regions: Europe, Africa, MENA and beyond." },
            { title: "Roadmap", desc: "A sequenced, realistic and manageable action plan." },
        ],
        outcomes: ["A clear vision of your export potential", "Justified priority markets", "An actionable roadmap"],
        solution: { slug: "developpement-international", label: "International development" },
    },
    {
        slug: "etudes-de-marche",
        num: "02",
        title: "Market studies",
        tagline: "Understand before investing.",
        image: "/assets/terrain-conference.jpg",
        imageAspect: "aspect-[4/3]",
        imageAlt: "WEYB conference — working on commercial strategy",
        intro: "An international decision should never be taken on intuition. WEYB's market studies give you a factual reading of target regions: demand, competition, regulation, distribution channels.",
        points: [
            { title: "International market studies", desc: "Complete analysis of a target market: size, players, prices, practices and barriers to entry." },
            { title: "Competitive analysis", desc: "Mapping local and international competitors, their positioning and pricing." },
            { title: "Market monitoring", desc: "Tracking regulatory, commercial and sector developments in your target regions." },
            { title: "AI-assisted studies", desc: "Through Export360, studies accelerated by artificial intelligence and reviewed by experts." },
        ],
        outcomes: ["Decisions based on facts", "A fine knowledge of your competitors", "Risks identified before investing"],
        solution: { slug: "developpement-international", label: "International development" },
    },
    {
        slug: "prospection-b2b-closing",
        num: "03",
        title: "B2B prospecting & closing",
        tagline: "Turning contacts into contracts.",
        image: "/assets/terrain-partenaire-digital.jpg",
        imageAspect: "aspect-[16/10]",
        imageAlt: "Technology partner visit — WEYB prospecting mission",
        intro: "International prospecting requires method, tooling and perseverance. WEYB identifies, qualifies and approaches your future partners — and supports you through to signature.",
        points: [
            { title: "Partner identification", desc: "Distributors, importers, agents or end clients: a precisely defined target." },
            { title: "Targeted B2B prospecting", desc: "Structured, documented and tracked campaigns — no purchased lists or mass mailings." },
            { title: "Qualification", desc: "Every contact is assessed: real interest, capacity, reliability, fit with your offer." },
            { title: "Sales closing", desc: "Support in negotiation and closing agreements, built on time and trust." },
        ],
        outcomes: ["A pipeline of qualified prospects", "Meetings with real decision-makers", "Support through to signature"],
        solution: { slug: "developpement-international", label: "International development" },
    },
    {
        slug: "salons-internationaux",
        num: "04",
        title: "International trade fairs",
        tagline: "Making every participation pay off.",
        image: "/assets/terrain-startup-village.jpg",
        imageAspect: "aspect-[4/3]",
        imageAlt: "WEYB mission — startup and innovation ecosystem",
        intro: "An international trade fair is prepared months in advance. WEYB turns your participation into a structured commercial operation, with meeting objectives and rigorous follow-up.",
        points: [
            { title: "Trade fair selection", desc: "Choosing the events genuinely suited to your markets and your offer." },
            { title: "Preparation", desc: "Objectives, pitch, materials and targeting of visitors and exhibitors to meet." },
            { title: "Meeting booking", desc: "Building an agenda of qualified meetings before you even arrive." },
            { title: "On-site support", desc: "Presence and assistance during the fair, then systematic follow-up of contacts." },
        ],
        outcomes: ["Framed, measurable participation", "An agenda of qualified meetings", "Post-fair follow-up that produces results"],
        solution: { slug: "developpement-international", label: "International development" },
    },
    {
        slug: "missions-b2b",
        num: "05",
        title: "B2B missions",
        tagline: "The field as an accelerator.",
        image: "/assets/terrain-enova.jpg",
        imageAspect: "aspect-[16/10]",
        imageAlt: "WEYB B2B mission — industrial company visit",
        intro: "Nothing replaces meeting in person. WEYB organises and supports your trade missions in target markets: qualified meetings, company visits, local immersion.",
        points: [
            { title: "Mission organisation", desc: "Programme, logistics and meeting agenda built around your objectives." },
            { title: "Qualified meetings", desc: "Encounters with partners identified and prepared in advance." },
            { title: "Field support", desc: "A WEYB expert by your side during the mission, including for negotiation." },
            { title: "Post-mission follow-up", desc: "Debrief, follow-ups and integration of opportunities into your export pipeline." },
        ],
        outcomes: ["Real immersion in your target market", "Relationships built face to face", "Opportunities followed up after your return"],
        solution: { slug: "developpement-international", label: "International development" },
    },
];
